// extracted by mini-css-extract-plugin
module.exports = {"div":"Details_div__323fL"};